var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "selectClass",
          attrs: { "label-position": "top", size: "small" },
        },
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap", "align-items": "center" },
              attrs: { justify: "start", type: "flex" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("basicData.OperationTime") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          clearable: true,
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("collectionCenter.EndTime"),
                          "start-placeholder": _vm.$t(
                            "collectionCenter.StartTime"
                          ),
                          "range-separator": "~",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: { change: _vm.dateChange },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("collectionCenter.CustomerName") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            "remote-method": _vm.getCustomerPage,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            change: _vm.getCustomerPage,
                            clear: _vm.getCustomerPage,
                          },
                          model: {
                            value: _vm.queryForm.params.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "customerId", $$v)
                            },
                            expression: "queryForm.params.customerId",
                          },
                        },
                        _vm._l(_vm.customerList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label:
                                item.customerAlias + "(" + item.username + ")",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.OperationSite"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            "remote-method": _vm.remoteGetSiteList,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            change: _vm.remoteGetSiteList,
                            clear: _vm.remoteGetSiteList,
                          },
                          model: {
                            value: _vm.queryForm.params.siteId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "siteId", $$v)
                            },
                            expression: "queryForm.params.siteId",
                          },
                        },
                        _vm._l(_vm.siteList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.operator") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            "remote-method": _vm.getOperator,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            change: _vm.getOperator,
                            clear: _vm.getOperator,
                          },
                          model: {
                            value: _vm.queryForm.params.createUser,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "createUser", $$v)
                            },
                            expression: "queryForm.params.createUser",
                          },
                        },
                        _vm._l(_vm.operatorList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.realName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selectClass01",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseChoose"
                                    ),
                                    filterable: "",
                                    size: "small",
                                  },
                                  on: { change: _vm.changeNum },
                                  model: {
                                    value: _vm.chooseOrder,
                                    callback: function ($$v) {
                                      _vm.chooseOrder = $$v
                                    },
                                    expression: "chooseOrder",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.returnWaybillNumber"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.scanOrderNumbers"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("collectionCenter.max200Line"),
                          autosize: "",
                          clearable: "",
                          type: "textarea",
                        },
                        on: { blur: _vm.ft },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.BlockNewlineNum($event)
                          },
                        },
                        model: {
                          value: _vm.returnOrder,
                          callback: function ($$v) {
                            _vm.returnOrder = $$v
                          },
                          expression: "returnOrder",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.orderPlacementResult"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryForm.params.operateStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "operateStatus",
                                $$v
                              )
                            },
                            expression: "queryForm.params.operateStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.tudo"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "orderCenterCont.orderWasPlacedSuccessfully"
                              ),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("newOrder.FailedOrder"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "margin-left": "10px" }, attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.searchClick },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("operationCenter.Procurar")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "info" },
                      on: { click: _vm.resetClick },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("collectionCenter.reset")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.exportDataFun },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("collectionCenter.export")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            "max-height": 620,
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.ind"),
              align: "center",
              width: "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.queryForm.pageNumber - 1) *
                            _vm.queryForm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.returnWaybillNumber"),
              align: "center",
              prop: "waybillNumber",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "top",
                          "popper-class": "copy",
                          trigger: "hover",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              color: "black",
                              "font-size": "12px",
                              padding: "2px",
                            },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.copy(scope.row.waybillNumber)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("orderDetails.copy")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#4fa5ff",
                              cursor: "pointer",
                            },
                            attrs: { slot: "reference" },
                            on: {
                              click: function ($event) {
                                return _vm.viewDetails(scope.row)
                              },
                            },
                            slot: "reference",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.waybillNumber || "--") +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.scanOrderNumbers"),
              align: "center",
              prop: "scanOrderNumber",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "top",
                          "popper-class": "copy",
                          trigger: "hover",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              color: "black",
                              "font-size": "12px",
                              padding: "2px",
                            },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.copy(scope.row.scanOrderNumber)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("orderDetails.copy")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [_vm._v(_vm._s(scope.row.scanOrderNumber || "--"))]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.CustomerName"),
              align: "center",
              prop: "customerName",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.customerName || "--"))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.orderPlacementResult"),
              align: "center",
              prop: "operateStatusValue",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("trajectory.LatestTracks"),
              align: "center",
              prop: "lastTrackDescribe",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(scope.row.lastTrackDescribe || "--")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.operator"),
              align: "center",
              prop: "createUserName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.OperationSite"),
              align: "center",
              prop: "siteName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.OperationTime"),
              align: "center",
              prop: "createTime",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.operation"),
              align: "center",
              width: "110",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operateStatus !== 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.printClick(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("collectionCenter.Print")) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100, 500, 1000],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.searchClick,
              "size-change": _vm.searchClick1,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("collectionCenter.returnNote"),
            visible: _vm.waybillDescription.visible,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.waybillDescription, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "calc(100vh - 67px)", overflow: "auto" } },
            [
              _c("waybill-information", {
                key: _vm.showQueryTrack.trackKey,
                attrs: {
                  "query-track-param": _vm.TrackParam,
                  "query-type": "1",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }